import {
  Box,
  Flex,
  Stack,
  Text,
  Image,
  Heading,
  Icon,
  HStack,
} from "@chakra-ui/react";
import { FaFacebook, FaInstagram, FaTiktok, FaYoutube } from "react-icons/fa";
import footerlogo from "../../assets/images/footerlogo.png";
import { links } from "../../data/Navbar";

const handleInstagramClick = () => {
  window.open("https://www.instagram.com/ideatorscup?igsh=aWdxMTI4c3I0d3Zm", "_blank");
};

const Footer = () => {
  return (
    <Flex bg="black" color="white" py={10}>
      <Box w="90%" mx="auto">
        <Flex
          direction={{ base: "column", md: "row" }}
          rowGap={{ base: 6, lg: 0 }}
          justify="space-between"
        >
          <Stack>
            <Heading color={"brand.150"} fontSize={"28px"}>
              CONTACT US
            </Heading>
            <Text
              mt={{ base: 0, lg: 4 }}
              fontSize={{ base: "16px", lg: "18px" }}
            >
              hello@ideatorscup.org
            </Text>

            <Text fontSize={{ base: "16px", lg: "18px" }}>
              Office Address : 2600 S Gessner Rd, Suite 420-17, Houston, TX,
              77063{" "}
            </Text>
            <Text fontSize={{ base: "16px", lg: "18px" }}>
              Mailing Address : P.O BOX 770161, Houston, TX, 77215 (Attn:
              INTERNATIONAL IDEATORS CUP)
            </Text>
            <Text fontSize={{ base: "16px", lg: "18px" }}>888-512-2168</Text>
            <Flex mt={2} gap={2} flexWrap={"wrap"}>
              <Icon as={FaFacebook} boxSize={6} />
              <Icon as={FaInstagram} boxSize={6} onClick={handleInstagramClick} cursor={'pointer'} />
              <Icon as={FaTiktok} boxSize={6} />
              <Icon as={FaYoutube} boxSize={6} />
            </Flex>
          </Stack>

          <Flex gap={{ base: 6, lg: 12 }} flexWrap={"wrap"}>
            <Stack spacing={3} w="fit-content">
              <Heading fontSize={"22px"} fontWeight={"500"}>
                QUICK LINKS
              </Heading>

              {links.map((link, index) => (
                <Box key={index} w="100%">
                  <Text
                    as="a"
                    onClick={(event) => {
                      event.preventDefault();
                      const sectionId = link.href.replace("/", "");
                      const section = document.getElementById(sectionId);

                      if (section) {
                        section.scrollIntoView({
                          behavior: "smooth",
                          block: "center",
                        });
                      }
                    }}
                    cursor="pointer"
                  >
                    {link.label}
                  </Text>
                </Box>
              ))}
            </Stack>

            <Stack spacing={3} >
              <Heading fontSize={"22px"} fontWeight={"500"}>
                IDEATORS CUP
              </Heading>
              <Flex gap={5} flexWrap={"wrap"}>
                <Stack>
                  <Text fontSize={{ base: "16px", lg: "18px" }}>Pakistan</Text>
                  <Text fontSize={{ base: "16px", lg: "18px" }}>Cyprus</Text>
                  <Text fontSize={{ base: "16px", lg: "18px" }}>Thailand</Text>
                  <Text fontSize={{ base: "16px", lg: "18px" }}>Malaysia</Text>
                  <Text fontSize={{ base: "16px", lg: "18px" }}>Azerbijan</Text>

                </Stack>
                {/* <Stack>
                </Stack> */}
              </Flex>
            </Stack>
          </Flex>
        </Flex>

        <Box mt={12}>
          <Image objectFit="contain" src={footerlogo}></Image>
        </Box>
        <HStack justifyContent={"flex-end"} mt={10} flexWrap={"wrap"}>
          <Text fontSize="sm">
            Copyright © 2024 INTERNATIONAL IDEATORS CUP. All Rights Reserved.
          </Text>
        </HStack>
      </Box>
    </Flex>
  );
};

export default Footer;
